import {
  Paragraph as GlobalParagraph,
  LeftAlignedWrapper,
} from "App/global-style";

import { Step } from "@storebrand-digital/insurance-stepper";
import styled from "styled-components";

interface Props {
  noActiveStep: boolean;
  steps: Step[];
}
export const CustomLeftAlignedMain = styled(LeftAlignedWrapper)<Props>`
  @media screen and (max-width: 768px) {
    & > div {
      ${({ noActiveStep }) =>
        noActiveStep &&
        `
          #content-container {
            grid-area: unset;
          }
      `}
      ${({ noActiveStep, steps }) =>
        noActiveStep &&
        steps.map(
          (step) => `
            #step-container-${step.id} {
              display: none;
            }
          `,
        )}
    }
  }
`;

export const Paragraph = styled(GlobalParagraph)`
  max-width: 550px;
`;

export const TopLineWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: var(--spacer-xs);
  justify-content: space-between;
  margin-bottom: var(--spacer-xs);
  width: 100%;
`;
